module.exports = __webpack_public_path__ + "static/media/17.688e2e9c.jpg";